import { render, staticRenderFns } from "./PatientPicker.vue?vue&type=template&id=1789ba8d&scoped=true"
import script from "./PatientPicker.vue?vue&type=script&lang=js"
export * from "./PatientPicker.vue?vue&type=script&lang=js"
import style0 from "./PatientPicker.vue?vue&type=style&index=0&id=1789ba8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1789ba8d",
  null
  
)

export default component.exports